module.exports = __webpack_public_path__ + "static/media/tech-job-1.78c2cec1.png";